var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-app-bar',{attrs:{"height":"30","app":"","color":"primary","dark":""}},[_c('MHEADER')],1),_c('v-main',{staticClass:"maintainer"},[_c('div',{staticClass:"maindiv",style:(_vm.marginResize)},[_c('PANBAN'),_c('STANSHEET'),_c('FOOTER')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }